import React, { useState } from "react";
import { Row, Col, Card, CardBody, Nav, NavItem, NavLink, Button } from "reactstrap";
import { useTranslation } from "react-i18next";
import classnames from "classnames";
import { connect } from "react-redux";
import OverallMetric from "../components/OverallMetric";
import InfoTooltip from "../components/InfoTooltip";
import DemographicsChart from "../components/DemographicsChart";
import Geography from "../components/Geography";
import BrandSources from "../components/BrandSources";
import BestSocialMediaPostBubbles from "../components/BestSocialMediaPostBubbles";
import PerformingSocialMediaPosts from "../components/PerformingSocialMediaPosts";
import VisibilityGraph from "../components/VisibilityGraph";
import EngagementGraph from "../components/EngagementGraph";
import PerformingSocialMediaMentions from "../components/PerformingSocialMediaMentions";
import PerformingSocialMediaTagged from "../components/PerformingSocialMediaTagged";
import EarnedMediaByAccountGraph from "../components/EarnedMediaByAccountGraph";
import LineGraph from "../components/LineGraph";
import BarGraph from "../components/BarGraph";
import LogoPlacementTable from "../components/LogoPlacementTable";
import MarketAnalysisTable from "../components/MarketAnalysisTable";
import { useSponsorStationDividedValue } from "../query/hooks";
import useSponsorTvDiveded from "../query/hooks/useSponsorTvDiveded";
import TrackedAccounts from "../components/TrackedAccounts";

const TABS = {
  TV: "tv",
  PRESS: "press",
  OWNED: "owned",
  EARNED: "earned",
  DISCOVER: "discover",
};

const MediaBetsson = ({ selectedCurrency }) => {
  const { t } = useTranslation();
  const [activeTab, setActiveTab] = useState(TABS.TV);

  const toggleTab = (tab) => {
    if (activeTab !== tab) {
      setActiveTab(tab);
    }
  };

  return (
    <div className="container-fluid pt-4">
      <Nav tabs className="nav-tabs-custom mb-4">
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.TV })}
            onClick={() => toggleTab(TABS.TV)}
            style={{ cursor: "pointer" }}
          >
            {t("media_tv")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.PRESS })}
            onClick={() => toggleTab(TABS.PRESS)}
            style={{ cursor: "pointer" }}
          >
            {t("media_press")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.OWNED })}
            onClick={() => toggleTab(TABS.OWNED)}
            style={{ cursor: "pointer" }}
          >
            {t("media_owned")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.EARNED })}
            onClick={() => toggleTab(TABS.EARNED)}
            style={{ cursor: "pointer" }}
          >
            {t("media_earned")}
          </NavLink>
        </NavItem>
        <NavItem>
          <NavLink
            className={classnames({ active: activeTab === TABS.DISCOVER })}
            onClick={() => toggleTab(TABS.DISCOVER)}
            style={{ cursor: "pointer" }}
          >
            {t("media_discover")}
          </NavLink>
        </NavItem>
      </Nav>

      {activeTab === TABS.TV && <TvTab selectedCurrency={selectedCurrency} t={t} />}
      {activeTab === TABS.PRESS && <PressTab t={t} />}
      {activeTab === TABS.OWNED && <OwnedTab t={t} />}
      {activeTab === TABS.EARNED && <EarnedTab t={t} />}
      {activeTab === TABS.DISCOVER && <DiscoverTab />}
    </div>
  );
};

const OwnedTab = ({ t }) => (
  <>
    <Row>
      <Col xl={6} md={6} className="mb-4">
        <OverallMetric
          metric="followers"
          tooltip={t("association_followers_tooltip")}
        />
      </Col>
      <Col xl={6} md={6} className="mb-4">
        <OverallMetric
          metric="engagement"
          followCalender
          tooltip={t("association_engagement_tooltip")}
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} md={6} className="mb-4">
        <Card className="mini-stat bg-card text-white">
          <CardBody>
            <h4 className="card-title mb-4">{t("Rekkevidde")}</h4>
            <VisibilityGraph />
          </CardBody>
        </Card>
      </Col>
      <Col sm={12} md={6} className="mb-4">
        <Card className="mini-stat bg-card text-white">
          <CardBody>
            <h4 className="card-title mb-4">{t("Engasjement")}</h4>
            <EngagementGraph />
          </CardBody>
        </Card>
      </Col>
    </Row>

    <Row>
      <Col sm={12} md={6} className="mb-4">
        <Card className="mini-stat bg-card text-white">
          <CardBody>
            <h4 className="card-title mb-4">
              {t("Geografi")}
              <InfoTooltip tooltip={t("association_geography_tooltip")} />
            </h4>
            <Geography />
          </CardBody>
        </Card>
      </Col>
      <Col sm={12} md={6} className="mb-4">
        <Card className="mini-stat bg-card text-white">
          <CardBody>
            <h4 className="card-title mb-4">
              {t("Alder og kjønn")}
              <InfoTooltip tooltip={t("association_demographics_tooltip")} />
            </h4>
            <DemographicsChart />
          </CardBody>
        </Card>
      </Col>
    </Row>

    <Row className="mb-4">
      <Col md={12}>
        <BestSocialMediaPostBubbles />
      </Col>
    </Row>

    <Row>
      <Col md={12} className="mb-4">
        <PerformingSocialMediaPosts type="BESTE" />
      </Col>
    </Row>

    <Row>
      <Col md={12} className="mb-4">
        <PerformingSocialMediaPosts type="SVAKESTE" />
      </Col>
    </Row>
  </>
);

const EarnedTab = ({ t }) => (
  <>
    <Row>
      <Col sm={12} className="mb-4">
        <Card className="mini-stat bg-card text-white">
          <CardBody>
            <h4 className="card-title mb-4">
              {t("earned_media_by_account")}
            </h4>
            <EarnedMediaByAccountGraph />
          </CardBody>
        </Card>
      </Col>
    </Row>

    <Row>
      <Col md={12} className="mb-4">
        <PerformingSocialMediaMentions />
      </Col>
    </Row>

    <Row>
      <Col md={12} className="mb-4">
        <PerformingSocialMediaTagged />
      </Col>
    </Row>
  </>
);

const TvTab = ({ selectedCurrency, t }) => (
  <>
    <Row className="mb-4">
      <Col sm={12} md={6} className="mb-4 mb-xl-0">
        <Card className="mini-stat bg-card text-white h-100">
          <CardBody>
            <h4 className="card-title mb-4">
              {t("Sponsorverdi per TV-kanal")} ({selectedCurrency.currency})
            </h4>
            <LineGraph
              useGraphQuery={useSponsorStationDividedValue}
              defaultActiveTab={0}
              queryParams={[0]}
            />
          </CardBody>
        </Card>
      </Col>
      <Col sm={12} md={6} className="mb-4 mb-xl-0">
        <Card className="mini-stat bg-card text-white h-100">
          <CardBody>
            <h4 className="card-title mb-4">{t("TV seere")}</h4>
            <BarGraph
              useGraphQuery={useSponsorTvDiveded}
              queryParams={[0]}
              scrollbar
              direction="horizontal"
            />
          </CardBody>
        </Card>
      </Col>
    </Row>

    <Row className="mb-4">
      <Col sm={12} md={6}>
        <Card className="mini-stat bg-card text-white h-100">
          <CardBody>
            <h4 className="card-title mb-4">{t("Logo Placement Analysis")}</h4>
            <LogoPlacementTable sponsorObjectId={0} />
          </CardBody>
        </Card>
      </Col>
      <Col sm={12} md={6}>
        <Card className="mini-stat bg-card text-white h-100">
          <CardBody>
            <h4 className="card-title mb-4">{t("Markets")}</h4>
            <MarketAnalysisTable sponsorObjectId={0} />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </>
);

const PressTab = ({ t }) => (
  <>
    <Row>
      <Col xl={6} md={6} className="mb-4">
        <OverallMetric
          followCalender
          metric="press-mentions"
          tooltip={t("association_pressMentions_tooltip")}
          noTrend
        />
      </Col>
      <Col xl={6} md={6} className="mb-4">
        <OverallMetric
          followCalender
          metric="sentiment"
          tooltip={t("association_sentiment_tooltip")}
          noTrend
          numeralFormat="0%"
          variant="ratio-bar"
        />
      </Col>
    </Row>

    <Row>
      <Col sm={12} className="mb-4">
        <Card className="mini-stat bg-card text-white">
          <CardBody>
            <h4 className="card-title mb-4">
              {t("Presseomtale")}
              <InfoTooltip tooltip={t("association_pressCoverage_tooltip")} />
            </h4>
            <BrandSources />
          </CardBody>
        </Card>
      </Col>
    </Row>
  </>
);

const DiscoverTab = () => <TrackedAccounts />;

const mapStateToProps = (state) => ({
  selectedCurrency: state.currency.selectedCurrency,
});

export default connect(mapStateToProps)(MediaBetsson);
